import * as React from 'react';
import './file-upload-button.scss';

interface IFileUploadButtonProps {
  fileFormat?: string;
  onFileUpload: (files: FileList | null) => void;
}

export default class FileUploadButton extends React.Component<IFileUploadButtonProps, {}> {
  public static defaultProps: Partial<IFileUploadButtonProps> = {
    fileFormat: '.pdf',
  };

  public readonly state: {} = {};

  public render() {
    return (
      <label className={'file-upload-button'}>
        Upload
        <input
          type={'file'}
          accept={this.props.fileFormat}
          onChange={this.onFileUpload}
          className={'file-upload-button--input'}
        />
      </label>
    );
  }

  private onFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onFileUpload(event.target.files);
  };
}
